namespace app.support.authorization {

    import IPermission = app.autenticacao.IPermission;

    /**
     * Gerenciar um subconjunto de permissões especificadas de algum contexto.
     * 
     */
    export class PermissionManager {

        constructor(private context: string, private permissions: IPermission[]) {

        }

        /**
         * Verifica se possui permissão de leitura, seja porque possui
         * permissão de execução ou porque possui permissão de apenas
         * leitura.
         * 
         * @param idRecurso 
         * @returns 
         */
        public hasRead(idRecurso: string): boolean {
            return !!this.permissions.find(p => p.id === idRecurso);
        }

        /**
         * Verifica se possui permissão de execução.
         * 
         * @param idRecurso 
         * @returns 
         */
        public hasExecute(idRecurso: string): boolean {
            return !!this.permissions.find(p => p.id === idRecurso && p.readOnly === false);
        }

        /**
         * Verifica se possui apenas a permissão de leitura, não
         * possuindo a de execução.
         * 
         * @param idRecurso 
         * @returns 
         */
        public hasOnlyRead(idRecurso: string): boolean {
            let hasRead = false;
            let hasExecute = false;
            this.permissions.forEach(p => {
                if (p.id == idRecurso && p.readOnly === true) {
                    hasRead = true;
                }

                if (p.id == idRecurso && p.readOnly === false) {
                    hasExecute = true;
                }
            });
            return hasRead && !hasExecute;
        }

    }

}